module.exports = __webpack_public_path__ + "media/images/sports_coaching/main_image1@3x-2a609402b337a786ee475f69b5859ef9.jpg";